import { render, staticRenderFns } from "./create-connection.vue?vue&type=template&id=16137d6b&"
import script from "./create-connection.vue?vue&type=script&lang=js&"
export * from "./create-connection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports